import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/axios";
import VerifyRegister from "./VerifyRegister";

export default function VerifySuccess() {
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        // Only post message if inside an iframe
        if (window.parent !== window.self) {
            window.parent.postMessage("login_success", "*");
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4">
            <img src="logo.png" alt="Logo" className="max-w-[200px] w-full mb-6" />
            <div className="bg-[#E3BCF4] p-8 rounded-2xl shadow-xl w-full max-w-md">
                <h2 className="text-2xl font-bold text-center mb-6 text-[#9B20AC]">Account Verified</h2>
            </div>
        </div>
    );
}
